//@core
const { getLanguage } = require('core/i18n').i18n;
import moment from 'moment';
// helper
import { getDepositOfferData } from '../../../utilities/depositHelper';
// constants
import { DIFFERENT_TIN_AND_TAE, NO_POST_RENOVATION, NO_ROBINSON, NO_TAE, POST_RENOVATION, ROBINSON, SAME_TIN_AND_TAE } from '../UI/depositOffersItem/constants/poeKeys';
import { 
    DEPOSITS_RENEWALS_AVAILABLE_FLOWS, 
    LAST_DAY_AMOUNT, 
    LAST_DAY_AMOUNT_POST, 
    DEPOSITS_RENEWAL_SCHEDULED, 
    RENEWAL_DEPOSIT_HIRING_FLOW, 
    RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION, 
    RENEWAL_OFFERS_LANDING, 
    EXPIRED_RENEWAL_OFFERS_LANDING 
} from '../../deposits/constants/depositsConstants';

export const getFullDate = (date) => {
    let formattedDate;
    if (date) {
        formattedDate = moment(date).locale(getLanguage()).format('DD MMM YYYY');
    }
    else {
        formattedDate = '-';
    }
    return formattedDate;
};

export const getOfferText = (isRobinson, isPostRenovation, tae, tin, poeKeys) => {
    const renovationEntry = isPostRenovation ? POST_RENOVATION : NO_POST_RENOVATION;
    const robinsonEntry = isRobinson ? ROBINSON : NO_ROBINSON;
    let taeEntry;
    if (tae) {
        taeEntry = tae === tin ? SAME_TIN_AND_TAE : DIFFERENT_TIN_AND_TAE;
    } else {
        taeEntry = NO_TAE;
    }
    return isPostRenovation ? poeKeys[renovationEntry][taeEntry] : poeKeys[renovationEntry][robinsonEntry][taeEntry];
}

export const isLastDay = (isPostRenovation, daysLeft) => {
    if (isPostRenovation) {
        return daysLeft === LAST_DAY_AMOUNT_POST;
    } else {
        return daysLeft === LAST_DAY_AMOUNT;
    }
}

export const getRenovationState = (flowId) => {
    const haveRenovated = flowId === DEPOSITS_RENEWAL_SCHEDULED;
    const isRenewableFlow = DEPOSITS_RENEWALS_AVAILABLE_FLOWS.includes(flowId);
    const haveRenewable = isRenewableFlow;
    const haveSimpleRenewable = flowId === RENEWAL_DEPOSIT_HIRING_FLOW || flowId === RENEWAL_DEPOSIT_HIRING_FLOW_POST_EXPIRATION;
    const haveComplexRenewable = flowId === RENEWAL_OFFERS_LANDING || flowId === EXPIRED_RENEWAL_OFFERS_LANDING;

    return { haveRenewable, haveRenovated, haveSimpleRenewable, haveComplexRenewable };
}

export const getCompleteRenovationState = (immImpositions, offersData, immDeposit) => {
    const depositOfferData = getDepositOfferData(immDeposit.getIn(['contract', 'contractNumber']), offersData);
    const haveMultiImpositions = immImpositions.size > 1
    const defaultState = { haveMultiImpositions, havePostRenovation: false, haveRenewable: false, haveRenovated: false, haveSimpleRenewable: false, haveComplexRenewable: false };
    
    if (depositOfferData) {
        const flowId = depositOfferData.flowId;
        const isPostRenovation = depositOfferData.isPostRenovation;
        
        const state = getRenovationState(flowId);
        return { ...defaultState, ...state, havePostRenovation: isPostRenovation };
    } else {
        return defaultState;
    }
}

export const goToOffersLanding = (history, id, flowId) => {
    const query = {
        depositId: id,
        flowId
    }
    history.push({
        query,
        pathname: '/myprofile/offers'
    });
}

export const goToDeposits = (history, depositIdentify, immDeposit, offerData, url, callbackFunction = null) => {
    if (offerData) {
        callbackFunction && callbackFunction(depositIdentify, immDeposit.get('id'), offerData.amount);
        history.push(url);
    }
}

export const getImpositionToHideOffer = (immContract, immImpositions) => {
    const impostionList = []
    immImpositions.map((imposition) => {
        impostionList.push({
            originalDepositImpositionNumber: imposition.get('id'),
            originalImpositionExpirationDate: imposition.get('expirationDate')
        })
    })

    return {
        originalDepositContract: immContract.get('contractNumber'),
        originalDepositImpositions: impostionList
    }
}